<div class="w-full">

  @if (tiles.length > 0) {
  <ngu-carousel #myCarousel [inputs]="carouselTile" class="rounded-2xl -bg-gray-300 m-4 mb-0" [dataSource]="tiles">

    <ngu-tile *nguCarouselDef="let item; let i = index" class="!rounded-2xl p-1 bganim relative new25_bg">
      <div (mouseenter)="generateMatrix()" class="text-gray-600 body-font grid grid-cols-1 lg:grid-cols-3 items-center justify-center">
        <div class="p-2 md:p-4 md:col-span-2">

          <h2 [innerHTML]="getOptimisedDes(item.heading)"
            class="title-font text-[35px] sm:text-[40px] md:text-[50px] lg2:text-[40px] lg:text-[60px] xl2:text-[70px] xl:text-[75px] 2xl2:text-[80px] mb-4 font-extrabold leading-[38px] sm:leading-[38px] md:leading-[42px] lg:leading-[56px] xl:leading-[90px] text-white text-start md:text-end break-words">
          </h2>
          <h2 class="mb-8 text-lg leading-5 sm:leading-8 sm:text-2xl lg:text-lg text-end font-mono text-white">
            {{ item.description }}&nbsp;&nbsp;
          </h2>

          <div class="flex justify-end items-center md:items-end">

            <button *ngIf="link(item)"
              class="relative inline-flex items-center justify-center p-[4px] mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-red-500 to-orange-400 group-hover:from-red-500 group-hover:to-orange-400 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-pink-200 dark:focus:ring-pink-800">
              <a [href]="linkAlterParams(item.link)"
                class="relative px-5 py-2.5 transition-all ease-in duration-75 bg-black dark:bg-black text-white rounded-md group-hover:bg-transparent group-hover:dark:bg-transparent font-bold text-2xl ">
              &nbsp;&nbsp;&nbsp;View Now&nbsp;&nbsp;&nbsp;
              </a>
            </button>

          </div>
        </div>

        <div #carodiv2 class="flex flex-col justify-stretch items-center md:col-span-1" *ngIf="i > 0">
          <app-img-c class="aspect-square w-full h-full grow hidden md:block" [alt]="item.heading" loading="eager" [url]="urlAdjust1stIndex(item.image1, 800)"
            [size]="800" [i]="i"></app-img-c>
          <app-img-c class="aspect-square w-full h-full grow block md:hidden" [alt]="item.heading" loading="eager" [url]="urlAdjust1stIndex(item.image1, 400)"
            [size]="600" [i]="i"></app-img-c>
        </div>

        <div #carodiv class="flex flex-col justify-center items-center aspect-square w-full h-full" *ngIf="i === 0">
          <app-img-c class="aspect-square w-full h-full grow block sm:hidden" [alt]="item.heading" loading="eager" [url]="urlAdjust1stIndex(item.image1, 600)"
            [size]="800" [i]="i"></app-img-c>
          <app-img-c class="aspect-square w-full h-full grow hidden sm:block md2:hidden" [alt]="item.heading" loading="eager"
            [url]="urlAdjust1stIndex(item.image1, 650)" [size]="800" [i]="i"></app-img-c>
          <app-img-c class="aspect-square w-full h-full grow hidden md2:block md:hidden" [alt]="item.heading" loading="eager"
            [url]="urlAdjust1stIndex(item.image1, 750)" [size]="800" [i]="i"></app-img-c>
          <app-img-c class="aspect-square w-full h-full grow hidden md:block" [alt]="item.heading" loading="eager" [url]="urlAdjust1stIndex(item.image1, 850)"
            [size]="800" [i]="i"></app-img-c>
        </div>
      </div>
    </ngu-tile>
  </ngu-carousel>

  <span class="myPoint !w-full justify-center p-2 md:p-4 flex" NguCarouselPoint>
    <span *ngFor="let item of tiles; let ii = index" [class.pointActive]="ii == myCarousel.activePoint"
      class="p-1 rounded-lg justify-center items-center flex w-full gap-1 !grow opacity-35 anim point border-2 border-solid border-gray-500 hover:opacity-100 hover:border-gray-800 cursor-pointer"
      (click)="myCarousel.moveTo(ii)">
    </span>
  </span>

  } @else {
  <!-- Skeleton placeholder while carousel data loads -->
  <div class="rounded-2xl m-4 mb-0 animate-pulse bg-gray-800/40" style="min-height: 320px;"></div>
  }

</div>